<script setup lang="ts">
import { PhCaretLeft, PhCaretRight, PhDownloadSimple, PhX } from "@phosphor-icons/vue";

import StatusAlert from "../components/StatusAlert.vue";
</script>

<template>
  <section id="libraryView" class="library-view" hidden>
    <header class="view-header">
      <button id="libraryBackButton" class="icon-button" type="button" aria-label="返回素材总览">
        <PhCaretLeft :size="18" weight="bold" aria-hidden="true" />
      </button>
      <div class="view-title-group">
        <h2 id="libraryTitle">商品主图</h2>
        <span id="libraryCount">0 个素材</span>
      </div>
      <div class="download-group-control">
        <button
          id="downloadGroupButton"
          class="download-group-button"
          type="button"
          aria-label="下载当前列表中已选的 0 个素材"
          title="下载当前列表中已选的 0 个素材"
          hidden
        >
          <span id="downloadGroupProgressFill" class="download-button-progress-fill" aria-hidden="true"></span>
          <PhDownloadSimple class="download-group-icon" :size="17" weight="bold" aria-hidden="true" />
          <span class="button-progress" aria-hidden="true"></span>
          <span id="downloadGroupLabel" class="download-group-label">下载已选</span>
          <span id="downloadGroupCount" class="download-group-count">0</span>
        </button>
        <button
          id="downloadGroupCancelButton"
          class="download-inline-cancel download-inline-cancel--group"
          type="button"
          aria-label="取消当前下载"
          title="取消当前下载"
          hidden
        >
          <PhX :size="12" weight="bold" aria-hidden="true" />
        </button>
      </div>
    </header>
    <StatusAlert
      alert-id="libraryDownloadAlert"
      text-id="libraryDownloadAlertText"
      close-id="libraryDownloadAlertClose"
      close-label="关闭当前列表下载通知"
    />
    <div id="mediaScrollShell" class="media-scroll-shell">
      <div id="mediaGrid" class="media-grid"></div>
      <span class="media-scrollbar" aria-hidden="true"><span id="mediaScrollbarThumb" class="media-scrollbar-thumb"></span></span>
    </div>
    <div id="videoStage" class="video-stage" hidden>
      <video id="videoPlayer" controls preload="metadata"></video>
      <input
        id="videoSelectionCheckbox"
        class="media-selection-checkbox detail-selection-checkbox"
        type="checkbox"
        aria-label="选择当前视频"
      />
      <div id="videoNavigation" class="viewer-footer">
        <button id="videoPreviousButton" class="viewer-arrow" type="button" aria-label="上一个视频">
          <PhCaretLeft :size="18" weight="bold" aria-hidden="true" />
        </button>
        <span id="videoCounter">1 / 1</span>
        <button id="videoNextButton" class="viewer-arrow" type="button" aria-label="下一个视频">
          <PhCaretRight :size="18" weight="bold" aria-hidden="true" />
        </button>
      </div>
    </div>
  </section>
</template>
